<div class="terms" *ngIf="tnc">
  <h1 class="heading-l">{{ tnc.title }}</h1>
  <div [class.modal__scrollable]="scroll === true">
    <markdown ngPreserveWhitespaces>
      {{ tnc.content }}
    </markdown>
  </div>
</div>
